import administrationCenter from './administrationCenter';
import manager from './manager';

// ==============================|| MENU ITEMS ||============================== //
const menuManager = {
  items: [manager, administrationCenter],
};

export default menuManager;
